module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"NumberofEmployee":" 出勤従業員数","AttendanceStaff":"出勤従業員名","ProductTrends":"商品動向","StoreStatus":"店舗状況（結果要因）","Inhousesituation":"百貨店状況","Author":"報告者名"}}')
  delete Component.options._Ctor
}
